import { IBusinessUnit } from 'src/shared/types/Common';
import { ICompanyWorkLocation, ICompanyEntity } from 'src/shared/types/Company';
import { IManagerContact } from 'src/shared/types/Company';
import { createApiFetcher } from 'src/utils/ApiUtils';
import {
  COMPANY_ENTITIES_KEY,
  MANAGER_CONTRACTS_KEY,
  COMPANY_BUSINESS_UNITS_KEY,
  WORK_LOCATIONS_KEY,
} from 'src/utils/constants/queryKeys';

const fetchData = createApiFetcher('company/');

export const getManagerContacts = (companyId: number): Promise<IManagerContact[]> =>
  fetchData(MANAGER_CONTRACTS_KEY, { companyId });

export const getCompanyEntities = (params: object): Promise<ICompanyEntity[]> =>
  fetchData(COMPANY_ENTITIES_KEY, { ...params });

export const getBusinessUnits = (companyId: number): Promise<IBusinessUnit[]> =>
  fetchData(COMPANY_BUSINESS_UNITS_KEY, { companyId });

export const getCorporateLocations = (
  companyId: number,
  companyEntityId?: string,
  primaryOnly?: boolean
): Promise<ICompanyWorkLocation[]> => fetchData(WORK_LOCATIONS_KEY, { companyId, companyEntityId, primaryOnly });
